import DatePicker from 'element-ui/lib/date-picker'
import BasePicker from './BasePicker.vue'

export default {
  extends: DatePicker,
  mixins: [BasePicker],
}
